/**
 * Nginx autoindex HTML çıktısını parse eder.
 * <pre> içinde: <a href="...">label</a>  09-May-2026 14:13   4G
 *
 * @param {string} html - sunucudan gelen ham HTML
 * @returns {Array<{name, href, isDir, date, size}>}
 */
export function parseNginxIndex(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const pre = doc.querySelector('pre');
  if (!pre) return [];

  const items = [];
  const children = Array.from(pre.childNodes);

  for (let i = 0; i < children.length; i++) {
    const node = children[i];
    if (node.nodeType !== Node.ELEMENT_NODE || node.tagName !== 'A') continue;

    const href = node.getAttribute('href') || '';
    const name = (node.textContent || '').trim();

    // Üst dizin atla
    if (href === '../' || name === '../') continue;

    const next = children[i + 1];
    let dateStr = '';
    let sizeStr = '';
    if (next && next.nodeType === Node.TEXT_NODE) {
      const txt = next.textContent.replace(/\n/g, '').trim();
      const match = txt.match(/^(\S+\s+\S+)\s+(\S+)\s*$/);
      if (match) {
        dateStr = match[1];
        sizeStr = match[2] === '-' ? '' : match[2];
      }
    }

    const isDir = href.endsWith('/');
    items.push({
      name: name.replace(/\/$/, ''),
      href,
      isDir,
      date: dateStr,
      size: sizeStr,
    });
  }

  return items;
}
